module.exports = __webpack_public_path__ + "media/scar.56c06171.wav";